import React from 'react';
import { roundedHumanFormat } from '~/utils/Price/Price';
import { PackMonthDataResponse } from 'com.cogvio.pricemonitor.api';

const calculateModelSumPrices = (data: PackMonthDataResponse[]) =>
	data.reduce(
		(sum: null | number, monthData) => (monthData.price.value ? Number(sum || 0) + Number(monthData.price.value) : sum),
		null
	) || NaN;

export const calculateModelAverage = (model: PackMonthDataResponse[]) => {
	const modePriceSum = calculateModelSumPrices(model);

	return !isNaN(modePriceSum) ? modePriceSum / (model.length || 0) : NaN;
};

export const renderModelAverage = (model: PackMonthDataResponse[], currency: string) => {
	const revenueAverage = calculateModelAverage(model);

	return !isNaN(revenueAverage) ? `${roundedHumanFormat(currency, String(revenueAverage))} / SKU` : 'NaN';
};

interface PriceBadgeAverageProps {
	currency: string;
	monthData: PackMonthDataResponse[];
	type?: 'big' | 'small';
}

export function PriceBadgeAverage({ currency, monthData, type }: PriceBadgeAverageProps) {
	const average = renderModelAverage(monthData, currency);
	return (
		<span
			className={`mr-1 mb-0.5 py-1.5 inline-block font-display text-label leading-none tracking-wider bg-cBlue-400 bg-opacity-10 align-top ${
				type === 'small' ? 'px-2 rounded-sm' : 'px-2.5 rounded'
			}`}
		>
			<span
				className={`text-[10px] leading-4 font-semibold text-gray-500 uppercase ${
					type === 'small' ? 'inline-block pr-1 align-top' : 'block'
				}`}
			>
				AVG price (in 4Y):
			</span>
			<strong
				className={`font-bold text-black tabular-nums ${
					type === 'small' ? 'inline-block text-[10px] leading-4 align-top' : 'block text-[14px] leading-tight'
				}`}
			>
				{average}
			</strong>
		</span>
	);
}
